import type { DatePickerProps } from 'antd';
import type { Dayjs } from 'dayjs';
import { forwardRef, type ReactNode, type Ref, type RefAttributes } from 'react';

export function forwardRefWithGenerics<T, P = any>(
    render: (props: P, ref: Ref<T>) => ReactNode,
): (props: P & RefAttributes<T>) => ReactNode {
    return forwardRef(render as any) as any;
}

export const disableFutureDateTimeProps: Pick<DatePickerProps, 'disabledDate' | 'disabledTime'> = {
    disabledDate(current: Dayjs | null) {
        return !!current && current.isAfter(new Date());
    },

    disabledTime(date: Dayjs) {
        const now = new Date();

        if (!date.isSame(now, 'day')) {
            return {};
        }

        return {
            disabledHours() {
                return Array.from({ length: 24 }, (_, i) => i).filter((item) => item > now.getHours());
            },

            disabledMinutes(selectedHour) {
                return selectedHour === now.getHours()
                    ? Array.from({ length: 60 }, (_, i) => i).filter((item) => item > now.getMinutes())
                    : [];
            },

            disabledSeconds(selectedHour, selectedMinute) {
                return selectedHour === now.getHours() && selectedMinute === now.getMinutes()
                    ? Array.from({ length: 60 }, (_, i) => i).filter((item) => item > now.getSeconds())
                    : [];
            },
        };
    },
};

export const DRAWER_CLOSING_ANIMATION_TIME = 300;
